import { makeStyles, Theme, Box } from '@material-ui/core';
import React from 'react';
import EditPencil from '../../components/EditPencil';
import CardSheet from '../../components/CardSheet';
import { InvestorOtherCriteria } from '../../types/types';
import { StyledText } from '../../components/StyledText';

interface InvestorOtherCriteriaPanelProps {
  investorOtherCriteria: InvestorOtherCriteria
  handleEdit?: () => void
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: theme.spacing(2),
    position: 'relative'
  },
  placeholder: {
    color: '#9896A7'
  },
  bodyText: {
    color: theme.palette.text.primary
  }
}));

const InvestorOtherCriteriaPanel: React.FC<InvestorOtherCriteriaPanelProps> = ({
  investorOtherCriteria,
  handleEdit
}) => {
  const styles = useStyles();
  const editable = handleEdit !== undefined;
  return (
    <div className={styles.root}>
      {editable && <EditPencil onClick={handleEdit} style={{ top: 10, right: 10, position: 'absolute' }} />}
      <CardSheet>
        <Box padding='50px 55px'>
          <Box>
            <StyledText variant='h2'>
              Other Criteria
            </StyledText>
          </Box>
          <Box marginTop='15px'>
            <StyledText variant='body1'>
              {investorOtherCriteria || 'Missing info (optional)'}
            </StyledText>
          </Box>
        </Box>
      </CardSheet>
    </div>
  );
};


export default InvestorOtherCriteriaPanel;
